import ActiveController from "rapid/controller";
import { cloneDeep } from "lodash";
export class emailPreviewController extends ActiveController {
    constructor($injector, $ToViewValue, $scope) {
        "ngInject";
        super($injector);
        this.toViewValue = $ToViewValue;
        this.previews = {
          print: {},
          digital: {}
        };
        this.mainBooth = null;
        this.boomerang = false;
        this.single = false;
        this.textTemplate = {
            english: {
                tip: "(Preview - please scroll down to the bottom of the email to download the video attachment.)",
                sharer: "How to share your image on Social Media:",
                step1: "1. Save your image locally on your device (on your phone: tap and hold the image)",
                step2: "2. Open Instagram, WhatsApp, Facebook or another app of your choice"
            },
            germanFormal: {
                tip: "(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)",
                sharer: "So teilen Sie Ihr Bild in Social Media:",
                step1: "1. Speichern Sie Ihr Foto lokal auf Ihrem Ger&auml;t ab (am Handy: auf das Bild tippen und gedr&uuml;ckt halten)",
                step2: "2. &Ouml;ffnen Sie Instagram&#44; WhatsApp&#44; Facebook oder eine andere App Ihrer Wahl"
            },
            germanInformal: {
                tip: "(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)",
                sharer: "So teilst du dein Bild&nbsp;in Social Media:",
                step1: "1. Speichere dein Foto lokal auf deinem Ger&auml;t ab (am Handy: auf das Bild tippen und gedr&uuml;ckt halten)",
                step2: "2. &Ouml;ffne Instagram&#44; WhatsApp&#44; Facebook oder eine andere App deiner Wahl"
            }
        };
        this.currentText = "uiufis";
        $scope.$watch(() => this.template, () => {
            switch (this.template) {
                case "English":
                    this.currentText = cloneDeep(this.textTemplate.english);
                    break;
                case "German formal":
                    this.currentText = cloneDeep(this.textTemplate.germanFormal);
                    break;
                case "German informal":
                    this.currentText = cloneDeep(this.textTemplate.germanInformal);
                    break;
            }
        });

        $scope.$watch(() => this.data, () => {
            if (this.data) {
                this.boomerang = false;
                this.single = false;
                try {
                    this.data = JSON.parse(this.data);
                    if (!this.data.gifBooth.enabled && !this.data.photoBooth.enabled && !this.data.boomerangBooth.enabled && !this.data.videoBooth.enabled) {
                        return;
                    }
                    this.data.photoBooth.printAreas = this.toViewValue.getArrayOfPrintingPhotos("photoBooth", this.data);
                    this.data.photoBooth.shareAreas = this.toViewValue.getSharingPhoto("photoBooth", this.data);

                    this.data.gifBooth.printAreas = this.toViewValue.getArrayOfPrintingPhotos("gifBooth", this.data);
                    this.data.gifBooth.stripAreas = this.toViewValue.getStrippedPhotos("gifBooth", this.data);
                    this.data.gifBooth.shareAreas = this.toViewValue.getSharingPhoto("gifBooth", this.data);

                    this.data.boomerangBooth.printAreas = this.toViewValue.getArrayOfPrintingPhotos("boomerangBooth", this.data);
                    this.data.boomerangBooth.stripAreas = this.toViewValue.getStrippedPhotos("boomerangBooth", this.data);
                    this.data.boomerangBooth.shareAreas = this.toViewValue.getSharingPhoto("boomerangBooth", this.data);

                    this.previews.print.enabled =
                        this.data.photoBooth.allowPrinting || this.data.gifBooth.allowPrinting || this.data.boomerangBooth.allowPrinting;
                    this.previews.digital.enabled =
                        this.data.photoBooth.allowSharing || this.data.gifBooth.allowSharing || this.data.boomerangBooth.allowSharing || this.data.videoBooth.allowSharing;

                    if (this.data.gifBooth.enabled) {
                        this.mainBooth = this.data.gifBooth;
                        this.logoType = "strip";
                    } else if (this.data.boomerangBooth.enabled) {
                        this.mainBooth = this.data.boomerangBooth;
                        this.logoType = "strip";
                        this.boomerang = true;
                    } else if (this.data.photoBooth.enabled) {
                        this.mainBooth = this.data.photoBooth;
                        this.logoType = "print";
                        this.single = true;
                    }
                    this.mainBooth.printAreas[0].random = Math.random() + "sf";
                    this.mainBooth.shareAreas[0].random = Math.random() + "sf";
                    this.fixedWidth = this.previews.print.enabled && this.previews.digital.enabled ? 107 : 224;

                } catch (e) {
                    //console.log(e);
                }
            }
        });
    }

    mergeArrays(arr1, arr2) {
        if (!arr2) return arr1;
        return [...arr1, ...arr2];
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/email-preview/email-preview.controller.js